import React from 'react';
import { SearchableSelect } from '../../../../components/ui/searchable-select';
import type { FieldInfo } from '../../engage-segments-tab/segment-definitions-api';

interface FieldSelectorProps {
  options: FieldInfo[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

/**
 * Field dropdown for segment conditions. Options come from API (fields_to_expose).
 * - id/value persisted to JSON = FieldInfo.name (jsonPath-derived); matches condition.field.
 * - label shown in dropdown = FieldInfo.label (friendly name) or name.
 */
export const FieldSelector: React.FC<FieldSelectorProps> = ({
  options,
  value,
  onChange,
  placeholder = 'Select field...',
  disabled = false,
}) => {
  const selectOptions = options.map(f => ({
    id: f.name,
    label: f.label ?? f.name,
  }));

  return (
    <SearchableSelect
      options={selectOptions}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};
